import HrUnavailabilityOverview, { HrUnavailabilityOverviewQueryParams } from "app/models/hrUnavailabilityOverview"

export enum Types {
  GET = "HR_UNAVAILABILITIES_OVERVIEW_GET",
  GET_SUCCESS = "HR_UNAVAILABILITIES_OVERVIEW_GET_SUCCESS",
  GET_FAIL = "HR_UNAVAILABILITIES_OVERVIEW_GET_FAIL",
}

export type Action =
  | GetHrUnavailabilitiesOverviewAction
  | GetHrUnavailabilitiesOverviewSuccessAction
  | GetHrUnavailabilitiesOverviewFailAction

export type GetHrUnavailabilitiesOverviewAction = {
  type: Types.GET
  payload: { params: HrUnavailabilityOverviewQueryParams }
}

export type GetHrUnavailabilitiesOverviewSuccessAction = {
  type: Types.GET_SUCCESS
  payload: { HrUnavailabilitiesOverview: HrUnavailabilityOverview[] }
}

export type GetHrUnavailabilitiesOverviewFailAction = {
  type: Types.GET_FAIL
  payload: { errors: object }
}

export function getHrUnavailabilitiesOverview(
  params: HrUnavailabilityOverviewQueryParams,
): GetHrUnavailabilitiesOverviewAction {
  return {
    payload: { params },
    type: Types.GET,
  }
}

export function getHrUnavailabilitiesOverviewSuccess(
  HrUnavailabilitiesOverview: HrUnavailabilityOverview[],
): GetHrUnavailabilitiesOverviewSuccessAction {
  return {
    payload: { HrUnavailabilitiesOverview },
    type: Types.GET_SUCCESS,
  }
}

export function getHrUnavailabilitiesOverviewFail(errors: object): GetHrUnavailabilitiesOverviewFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}
